/* global axios */
// A linha do tempo do sentimento de uma conversa
// (custom/app/controllers/api/v1/accounts/conversations/neuxs/sentimentos_controller.rb).

export const listaSentimentos = (accountId, conversationId) =>
  axios.get(
    `/api/v1/accounts/${accountId}/conversations/${conversationId}/neuxs/sentimentos`
  );
